module.exports = __webpack_public_path__ + "static/media/fiftyup-favicon.dc503c0b.ico";